import React from 'react'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { List, WhiteSpace, Flex, Toast } from 'antd-mobile'
import { Button, Modal } from 'components'
import _ from 'lodash'
import { ENUMS, intl, openUri } from 'utils'

export default class SelectPaymentMethod extends React.Component {
  constructor(props) {
    super(props)
    const defaultItem = _.get(props, 'paymentMethods[0]', {})
    this.state = {
      selectedItem: `h5Pay^${defaultItem.type}^${defaultItem.priority}`,
    }
  }

  handleSelectedItem = (selectedItem) => {
    this.setState({ selectedItem: selectedItem })
  }

  handleSubmit = () => {
    const { IapConfig, history, paymentMethods } = this.props
    const { selectedItem } = this.state
    const token = sessionStorage.getItem('token')
    const [type, payMethod] = selectedItem.split('^')
    if (type === 'openApp') {
      Toast.loading('', 3)
      const appConfig = _.chain(IapConfig)
        .get('items')
        .find({ appCode: payMethod })
        .value()
      setTimeout(() => {
        Modal.alert(
          intl.formatMessage(messages.alertTitle),
          <div className='text-left'>
            <p>{intl.formatMessage(messages.alertP1)}</p>
            <p>{intl.formatMessage(messages.alertP2)}</p>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={appConfig.appDownUrl}
            >
              <Flex className='app-download-link'>
                <img width='24' src={require('./images/gift.png')} />
                <div>Get your app and gain more points.</div>
                <span className='iconfont font-mdplus green iconarrow-right-small' />
              </Flex>
            </a>
          </div>,
          [
            {
              text: <span>{intl.formatMessage(messages.alertBtnBack)}</span>,
            },
            {
              text: (
                <span className='green'>
                  <b>{intl.formatMessage(messages.alertBtnConfirm)}</b>
                </span>
              ),
              onPress: () => history.push(`/payments/result?ft=${token}`),
            },
          ]
        )
      }, 3000)
      openUri(`${appConfig.redirectUrl}?ft=${token}&iapPartnerId=null&iapSign=null&iapDeviceId=null&iapAppId=null`)
      return false
    }

    // 缓存当前支付方式的数据并跳转到对应的流程
    const payMethodInfo = _.find(paymentMethods, { type: payMethod }, {})
    sessionStorage.setItem('payMethod', JSON.stringify(payMethodInfo))
    switch (payMethod) {
      case 'message_pay':
        history.push('/payments/message-pay')
        break
      case 'session_pay':
        if (payMethodInfo.redirectUrl.indexOf('/payments/cybersource') > -1) {
          // 通过redirectUrl区分渠道
          history.push('/payments/cybersource')
        } else {
          history.push('/payments/session-pay')
        }
        break
      default:
        break
    }
  }

  render() {
    const { paymentMethods = [], IapConfig = {} } = this.props
    const { selectedItem } = this.state
    return (
      <React.Fragment>
        <List className={classes.componentsSelectPaymentMethod}>
          {_.map(paymentMethods, (item, index) => {
            const paymethod = ENUMS.handlePayMethod(item)
            const uniqKey = `h5Pay^${paymethod.type}^${paymethod.priority}`
            return (
              <List.Item
                key={index}
                disabled={!paymethod.supportFlag}
                thumb={paymethod.thumb}
                extra={
                  <span
                    className={`iconfont font-md ${
                      uniqKey === selectedItem
                        ? 'iconRadio-Selected green'
                        : 'iconRadio'
                    }`}
                  />
                }
                onClick={() => this.handleSelectedItem(uniqKey)}
              >
                {paymethod.name}
                {paymethod.type === 'session_pay' && (
                  <React.Fragment>
                    <img className='small pull-right' src={require('images/MasterCard1.png')} />
                    <img className='small pull-right' src={require('images/VISA1.png')} />
                  </React.Fragment>
                )}
                {!paymethod.supportFlag && (
                  <List.Item.Brief>
                    <FormattedMessage {...messages.notAvailable} />
                  </List.Item.Brief>
                )}
              </List.Item>
            )
          })}
          {_.chain(IapConfig)
            .get('items', [])
            .reject({ appCode: 'payby-h5' })
            .map((item, index) => {
              const uniqKey = `openApp^${item.appCode}`
              return (
                <List.Item
                  key={index}
                  thumb={item.logoUrl}
                  extra={
                    <span
                      className={`iconfont font-md ${
                        uniqKey === selectedItem
                          ? 'iconRadio-Selected green'
                          : 'iconRadio'
                      }`}
                    />
                  }
                  onClick={() => this.handleSelectedItem(uniqKey)}
                >
                  {item.title}{' '}
                  {item.isRecommend === 'true' && (
                    <img src={item.recommendIcon} />
                  )}
                  {item.txtFont && (
                    <span
                      className={`pull-right ${classes.opText}`}
                      style={{ color: item.txtFont.txtColor }}
                    >
                      {item.txtFont.txt}
                    </span>
                  )}
                </List.Item>
              )
            })
            .value()}
        </List>
        <WhiteSpace size='lg' />
        <WhiteSpace size='lg' />
        <Button type='primary' name='pay' onClick={this.handleSubmit} />
      </React.Fragment>
    )
  }
}
